import { Stack, Typography } from '@mui/material';

import { SubpageLayout } from '@/components/architecture/Layout/SubpageLayout';
import { Card } from '@/components/layout/Card/Card';
import { Callout } from '@/components/notifications/Callout/Callout';
import { useCurrentUser } from '@/modules/authentication/hooks/useCurrentUser';
import {
  BehaviorAuthorizationType,
  useHasBehaviorAuthorization,
} from '@/modules/authentication/hooks/useHasBehaviorAuthorization';

import { useGetTenantSecurityConfigurationQuery } from './graphql/GetTenantSecurityConfiguration.generated';
import { SupportAccessForm } from './SupportAccessForm';

export function AdminSecurityPage() {
  const canEdit = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_EDIT_SECURITY_ADMIN_PAGE
  );
  const currentUser = useCurrentUser();
  const { data, loading, error } = useGetTenantSecurityConfigurationQuery();

  return (
    <SubpageLayout heading="Security">
      <Stack maxWidth={760} spacing={3}>
        <Stack spacing={2}>
          <Typography variant="title-l">Luminary support access</Typography>
          {currentUser?.isInternalUser && (
            <Callout severity="info-high">
              Luminary users are not able to edit this form. Changes must be
              made by an authorized tenant user.
            </Callout>
          )}
          {loading && <Typography variant="body-xs">Loading...</Typography>}
          {(error || (!loading && !data?.tenantSecurityConfiguration)) && (
            <Typography variant="body-xs">
              Unable to load tenant security configuration.
            </Typography>
          )}
          {data?.tenantSecurityConfiguration && (
            <Card variant="outlined" sx={{ p: 2 }}>
              <SupportAccessForm
                tenantSecurityConfiguration={data.tenantSecurityConfiguration}
                readOnly={!canEdit}
              />
            </Card>
          )}
        </Stack>
      </Stack>
    </SubpageLayout>
  );
}
